import { useTranslation } from 'react-i18next';

import Button from '../../atoms/Button/Button';
import Modal, { ModalHeader } from '../Modal/Modal';
import modalStyles from '../Modal/Modal.module.css';

/**
 * Confirmation modal for deleting one or more table rows.
 * @param {object} props
 * @param {string} [props.id='modal-delete-rows-confirm']
 * @param {boolean} props.isOpen
 * @param {() => void} props.onClose
 * @param {() => void} props.onConfirm
 * @param {number} props.count - Number of rows to delete
 * @param {boolean} [props.isLoading=false]
 * @returns {JSX.Element}
 */
function DeleteRowsConfirmModal({
  id = 'modal-delete-rows-confirm',
  isOpen,
  onClose,
  onConfirm,
  count,
  isLoading = false,
}) {
  const { t } = useTranslation();

  return (
    <Modal
      id={id}
      isOpen={isOpen}
      onClose={onClose}
      header={(
        <ModalHeader
          title={t('sidePanel.delete')}
          onClose={onClose}
        />
      )}
    >
      <p className={modalStyles['modal-message']}>
        {count === 1 ? t('sidePanel.confirmDeleteOne') : (
          <>
            {t('sidePanel.confirmDeleteMultiplePrefix')}
            {' '}
            <span className={modalStyles['modal-message-count']}>{count}</span>
            {' '}
            {t('sidePanel.confirmDeleteMultipleSuffix', { count })}
          </>
        )}
      </p>
      <div style={{
        display: 'flex', justifyContent: 'flex-end', gap: 'var(--spacing-s)', marginTop: 'var(--spacing-m)',
      }}
      >
        <Button
          color="primary100"
          size="small"
          onClick={onClose}
        >
          {t('sidePanel.cancel')}
        </Button>
        <Button
          color="primary"
          size="small"
          onClick={onConfirm}
          isLoading={isLoading}
          disabled={isLoading}
        >
          {t('sidePanel.delete')}
        </Button>
      </div>
    </Modal>
  );
}

export default DeleteRowsConfirmModal;
